import React, { FC } from "react";
import { formattedMoney } from "helpers/money";
import { cn } from "helpers/style";
import styles from "./Price.module.scss";

type Props = Partial<{
  value: string | number;
  prefix: string;
  currency: string;
  withoutPrefix: boolean;
  withoutCurrency: boolean;
  className: string;
  classNamePrefix: string;
  // TODO: can be removed after solving the problem with the assembly of styles module.scss
  isNewPriceStyle?: boolean;
}>;

const Price: FC<Props> = React.memo<Props>(
  ({
    value,
    prefix,
    currency = "₽",
    withoutPrefix,
    withoutCurrency,
    className,
    classNamePrefix,
    isNewPriceStyle,
    ...rest
  }) => {
    return (
      <div
        className={cn([
          isNewPriceStyle ? styles.newPrice : styles.price,
          className,
        ])}
        {...rest}
      >
        {prefix && !withoutPrefix ? (
          <span
            className={cn([
              isNewPriceStyle ? styles.newPricePrefix : styles.pricePrefix,
              classNamePrefix,
            ])}
          >
            {prefix}&nbsp;
          </span>
        ) : null}
        {formattedMoney(value)}
        {currency && !withoutCurrency ? ` ${currency}` : null}
      </div>
    );
  }
);

export default Price;
